import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { addItemToSubscription } from './AppService';
import { getAllItemsForApp } from './AppService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listItemChildren from './ItemChildrenList';

const AttachItem = ({ listAppItems, appId }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<any[]>([]);
  //const navigate = useNavigate();
  //const [name, setName] = useState('');
  //const [description, setDescription] = useState('');
  //const [status, setStatus] = useState('');
  const [selectedItemId, setSelectedItemId] = useState(null);
  const { subscriptionid } = useParams();
  const { itemid } = useParams();
  //const { appid } = useParams();
  const handleChange = (itemid) => {
    setSelectedItemId(itemid);
  };

  const handleClickOpen = () => {
    listAppItems();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listItems();
  }, [itemid, appId]);

  function listItems() {
    //const nextItemId = parseInt(sectionId) + 1;

    getAllItemsForApp(appId)
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedItem(appId, itemid) {
    // eslint-disable-next-line no-undef
    const item = { name, status };
    addItemToSubscription(subscriptionid, itemid, item)
      .then(() => {
        // appProgrammeList();
        listAppItems();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Item</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedItemId || ''} // Use selectedItemId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Item
                </option>
                {/* Map over items to generate options */}
                {items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button onClick={() => attachSelectedItem(appId, selectedItemId)}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachItem;
